export default {
    state: {
        callStatus: 0
    },
    mutations: {
        callPlus: (state) => {
            state.callStatus++
        },
        callMinus: (state) => {
            state.callStatus--
        },
        callClose: (state) => {
            state.callStatus = 0
        }
    },
    actions: {
        plusCall ({commit}) {
            commit('callPlus')
        },
        minusCall ({commit}) {
            commit('callMinus')
        },
        closeCall ({commit}) {
            commit('callClose')
        }
    },
    getters: {
        callStat (state) {
            return state.callStatus
        }
    }
}
